"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = exports.axiforma = void 0;
const core_1 = require("@emotion/core");
const backup = [
    '-apple-system',
    'system-ui',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica Neue',
    'Arial',
    'sans-serif',
];
exports.axiforma = (font) => [font, 'Questrial']
    .concat(backup)
    .map((f) => `"${f}"`)
    .join(', ');
exports.theme = {
    primary: '#00FF9C',
    secondary: '#205C3B',
    primaryDark: '#00d180',
    primaryLight: '#00FF9C',
    black: '#2E2837',
    lightBlack: '#322B3D',
    accent: '#9B98F6',
    error: '#FF466A',
    warning: '#FFC400',
    gray0: '#F8F5FD',
    grayHalf: '#F2EEF7',
    gray1: '#F2EAFE',
    gray2: '#CCBEE0',
    gray3: '#8E82A3',
    gray4: '#5B506B',
    gray5: '#40384C',
    gray6: '#362E43',
    hover: '#00d180',
    fonts: {
        axiformaBold: core_1.css `
      font-family: ${exports.axiforma('Axiforma-Bold')};
      font-style: normal;
      font-weight: 700;
    `,
        axiformaRegular: core_1.css `
      font-family: ${exports.axiforma('Axiforma-Regular')};
      font-style: normal;
      font-weight: 400;
    `,
        axiformaMedium: core_1.css `
      font-family: ${exports.axiforma('Axiforma-Medium')};
      font-style: normal;
      font-weight: 500;
    `,
        axiformaSemiBold: core_1.css `
      font-family: ${exports.axiforma('Axiforma-SemiBold')};
      font-weight: 600;
      font-style: normal;
    `,
        axiformaBook: core_1.css `
      font-family: ${exports.axiforma('Axiforma-Book')};
      font-weight: 200;
      font-style: normal;
    `,
        axiformaThin: core_1.css `
      font-family: ${exports.axiforma('Axiforma-Thin')};
      font-weight: 400;
      font-style: normal;
    `,
    },
    fontStyles: {
        caption: core_1.css `
      font-size: 0.8rem;
      line-height: 1.35em;
      text-align: left;
    `,
        body1: core_1.css `
      font-size: 0.875rem;
      line-height: 1.46428em;
      text-align: left;
    `,
        body2: core_1.css `
      font-size: 0.875rem;
      line-height: 1.71428em;
      text-align: left;
    `,
        display1: core_1.css `
      font-size: 2.125rem;
      line-height: 1.20588em;
      text-align: left;
    `,
        display2: core_1.css `
      font-size: 2.8125rem;
      line-height: 1.06666em;
      text-align: left;
    `,
        display3: core_1.css `
      font-size: 3.5125rem;
      line-height: 1.06666em;
      text-align: left;
    `,
        headline: core_1.css `
      font-size: 1.5rem;
      line-height: 1.35416em;
      text-align: left;
    `,
        subheading: core_1.css `
      font-size: 1rem;
      line-height: 1.7em;
      text-align: left;
    `,
    },
    breakpoints: {
        sm: '600px',
        md: '960px',
        lg: '1280px',
        xl: '1920px',
    },
    constants: {
        content: {
            width: '90%',
            maxWidth: '42em',
        },
    },
    Box: (props) => core_1.css `
    box-sizing: border-box;
    ${props.theme.fonts.axiformaRegular};
    ${props.theme.fontStyles.body1};
  `,
};

//# sourceMappingURL=theme.js.map
